export default "__VITE_ASSET__BZ_oNnEF__"